<template>
    <div class="introduction">
        <div class="top-wrapper">
            <img class="top-img" src="@/assets/imgs/introduction.png" alt="">
            <div class="mask">
                <img class="m-img" src="@/assets/imgs/id-icon.png" alt="">
                <div class="m-title">体验720°数字博物馆</div>
                <div class="btn cursor-pointer" @click="handleClick()">开 始 体 验</div>
            </div>
        </div>
        <div class="introduction-container">
            <div class="content">
                <div class="left">
                    <div class="title">【博物馆简介】</div>
                    <div class="desc">顺昌县博物馆位于城东塔山路，交通便利，环境优美，是顺昌县地标性建筑，同时，兼具城市客厅功能。顺昌县博物馆整体建筑外观，犹如一艘扬帆巨轮，依偎在富屯溪畔，象征着顺昌县在各级领导的关心支持下扬帆奋进。
                    </div>
                </div>
                <div class="right">
                    <img class="content-img-1" src="@/assets/imgs/update/jj1.png" alt="">
                </div>
            </div>
            <div class="content">
                <div class="left">
                    <img class="content-img-2" src="@/assets/imgs/update/jj2.png" alt="">
                </div>
                <div class="right">
                    <div class="desc">
                        <p>博物馆主体建筑于2019年1月开工，2021年12月通过竣工验收。主体建筑占地6164.5㎡，建筑面积10138.2㎡。建筑分为东、中、西三个部分。东侧为博物馆的主要功能区域，设有固定展厅2个；临时展厅1个、交流展厅1个，以及办公、学术报告、文化休闲、文创运营等区域。中部连廊主要设计为学术讲座、文旅推介、以及研学科普等社教功能区域。西侧为一二层通透设计，主要用于非遗展示、青少年活动、文创开发等。
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="introduction-2">
            <img src="@/assets/imgs/introduction2.png" alt="">
        </div>
        <div class="history-section">
            <div class="introduction-container">
                <div class="museum-overview">
                    <div class="section-title center">【博物馆概况】</div>
                    <div class="overview-desc">
                        顺昌县博物馆成立于1989年12月24日。顺昌县博物馆法定代表人王长军，编制5人，实有4人，为三级风险防范单位。馆藏文物1458件（套），其中二级文物23件（套），三级文物1002件（套），一般文物433件（套）。2008年1月起，顺昌县博物馆从原来的门票式有偿服务转变成实行免费开放。顺昌县博物馆新馆舍项目总投资约1.09亿元，主体建筑于2019年1月开工，2021年12月通过竣工验收。总用地面积约1.9万平方米，建筑面积约1万平方米，2024年6月顺昌县博物馆新馆面向社会全面免费开放，新馆的建成使用更好地满足了人民群众日益增长的精神文化需求，取得了较好的社会效益。
                    </div>
                </div>
                <!-- <div class="leaders-wrapper">
                    <div class="section-title">【历任领导】</div>
                    <div class="leaders-list">
                        <div class="leader-card" v-for="leader in leaders" :key="leader.id">
                            <img class="leader-img" :src="leader.img" alt="">
                            <div class="leader-info">
                                <div class="leader-name">{{ leader.name }}</div>
                                <div class="leader-position">{{ leader.position }}</div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="history-scroller">
                <div class="history-title">【馆史回顾】</div>
                <div class="history-viewport">
                    <div class="history-track"></div>
                    <div
                        class="history-motion"
                        :style="historyMotionStyle"
                        @transitionend="handleHistoryTransitionEnd"
                    >
                        <div
                            class="history-item"
                            v-for="item in renderedHistoryEvents"
                            :key="item.renderId"
                        >
                            <div class="timeline-point">
                                <span></span>
                                <div>{{ item.year }}</div>
                            </div>
                            <div class="history-card">
                                <div class="history-card-title">{{ item.title }}</div>
                                <div class="history-card-desc">{{ item.desc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-actions">
                    <button
                        class="history-btn"
                        type="button"
                        @click="handleHistoryPrev"
                    >
                        <i class="el-icon-caret-left"></i>
                    </button>
                    <button
                        class="history-btn"
                        type="button"
                        @click="handleHistoryNext"
                    >
                        <i class="el-icon-caret-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { MessageBox } from 'element-ui';
import leaderImg from '@/assets/imgs/update/jj1.png';

const leaders = [
    {
        id: 1,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 2,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 3,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 4,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 5,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 6,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 7,
        name: '姓名',
        position: '职称',
        img: leaderImg
    },
    {
        id: 8,
        name: '姓名',
        position: '职称',
        img: leaderImg
    }
];

const historyEvents = [
    {
        id: 1,
        year: '19xx年~19xx年',
        title: '馆内重大事件标题',
        desc: '顺昌县博物馆成立于1989年12月24日。顺昌县博物馆法定代表人王长军，编制5人，实有4人，为三级风险防范单位。馆藏文物1458件（套），其中二级文物23件（套），三级文物1002件（套），一般文物433件（套）。2008年1月起，顺昌县博物馆从原来的门票式有偿服务转变成实行免费开放。顺昌县博物馆新馆舍项目总投资约1.09亿元，主体建筑于2019年1月开工，2021年12月通过竣工验收。'
    },
    {
        id: 2,
        year: '19xx年~19xx年',
        title: '馆内重大事件标题',
        desc: '顺昌县博物馆成立于1989年12月24日。顺昌县博物馆法定代表人王长军，编制5人，实有4人，为三级风险防范单位。馆藏文物1458件（套），其中二级文物23件（套），三级文物1002件（套），一般文物433件（套）。2008年1月起，顺昌县博物馆从原来的门票式有偿服务转变成实行免费开放。顺昌县博物馆新馆舍项目总投资约1.09亿元，主体建筑于2019年1月开工，2021年12月通过竣工验收。'
    },
    {
        id: 3,
        year: '19xx年~19xx年',
        title: '馆内重大事件标题',
        desc: '顺昌县博物馆成立于1989年12月24日。顺昌县博物馆法定代表人王长军，编制5人，实有4人，为三级风险防范单位。馆藏文物1458件（套），其中二级文物23件（套），三级文物1002件（套），一般文物433件（套）。2008年1月起，顺昌县博物馆从原来的门票式有偿服务转变成实行免费开放。顺昌县博物馆新馆舍项目总投资约1.09亿元，主体建筑于2019年1月开工，2021年12月通过竣工验收。'
    },
    {
        id: 4,
        year: '19xx年~19xx年',
        title: '馆内重大事件标题',
        desc: '顺昌县博物馆新馆舍项目总投资约1.09亿元，主体建筑于2019年1月开工，2021年12月通过竣工验收。总用地面积约1.9万平方米，建筑面积约1万平方米。新馆的建成使用更好地满足了人民群众日益增长的精神文化需求，取得了较好的社会效益。'
    },
    {
        id: 5,
        year: '19xx年~19xx年',
        title: '馆内重大事件标题',
        desc: '顺昌县博物馆持续推进馆藏保护、陈列展示、公共教育和文化传播工作，围绕地方历史文化资源打造展览内容，进一步丰富群众文化生活，提升公共文化服务水平。'
    },
    {
        id: 6,
        year: '19xx年~19xx年',
        title: '馆内重大事件标题',
        desc: '顺昌县博物馆面向社会开展多样化社教活动，结合研学、讲座、展览和互动体验，推动地方文化资源活化利用，让更多观众走近博物馆、了解顺昌历史文化。'
    }
];

const historyVisibleCount = 3;
const historyItemGap = 25;
const historySideOverflow = 90;
const historyItemWidth = ref(430);
const historyScrollDistance = computed(() => historyItemWidth.value + historyItemGap);
const historyTransitionEnabled = ref(true);
const historyActiveIndex = ref(historyEvents.length);
const renderedHistoryEvents = computed(() => [...historyEvents, ...historyEvents, ...historyEvents].map((item, index) => ({
    ...item,
    renderId: `${index}-${item.id}`
})));
const historyMotionStyle = computed(() => ({
    '--history-item-width': `${historyItemWidth.value}px`,
    '--history-item-gap': `${historyItemGap}px`,
    '--history-visible-width': `${historyVisibleCount * historyItemWidth.value + (historyVisibleCount - 1) * historyItemGap}px`,
    transform: `translateX(-${historyActiveIndex.value * historyScrollDistance.value}px)`,
    transition: historyTransitionEnabled.value ? 'transform 0.45s ease' : 'none'
}));

const updateHistoryLayout = () => {
    historyItemWidth.value = (window.innerWidth + historySideOverflow - (historyVisibleCount - 1) * historyItemGap) / historyVisibleCount;
};

onMounted(() => {
    updateHistoryLayout();
    window.addEventListener('resize', updateHistoryLayout);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateHistoryLayout);
});

const handleHistoryPrev = () => {
    historyTransitionEnabled.value = true;
    historyActiveIndex.value -= 1;
};

const handleHistoryNext = () => {
    historyTransitionEnabled.value = true;
    historyActiveIndex.value += 1;
};

const resetHistoryPosition = (index) => {
    historyTransitionEnabled.value = false;
    historyActiveIndex.value = index;
    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
            historyTransitionEnabled.value = true;
        });
    });
};

const handleHistoryTransitionEnd = () => {
    if (historyActiveIndex.value >= historyEvents.length * 2) {
        resetHistoryPosition(historyActiveIndex.value - historyEvents.length);
    }
    if (historyActiveIndex.value < historyEvents.length) {
        resetHistoryPosition(historyActiveIndex.value + historyEvents.length);
    }
};

const handleClick = () => {
    // window.location.href='https://www.qofo360.com/jinlin/sxbwg/index.html'
    // window.open('https://www.qofo360.com/jinlin/bsfjq/index.html', '_blank');
    MessageBox.alert('正在建设中～', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        showConfirmButton: false
    });

};
</script>

<style lang="scss" scoped>
.introduction {
    .top-wrapper{
        position: relative;
        .mask{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,.5);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .m-title{
                font-family:sy-font,serif;
                font-weight:700;
                color: rgba(255, 255, 255, 0.60);
                font-size:53px;
                margin-top: 37px;
            }
            .m-img{
                width: 117px;
                height: 117px;
            }
            .btn{
                width:336px;
                height:94px;
                border: 3px solid rgba(255, 255, 255, 0.54);
                border-radius:48px;
                text-align: center;
                line-height: 94px;
                margin-top: 35px;
                font-weight:700;
                color:#ffffff;
                font-size:38px;
            }
        }
    }
    .top-img {
        width: 100%;
    }
    .content{
        margin-bottom: 65px;
        display: flex;
        justify-content: space-between;
        line-height:36px;
        .left{
            width: 584px;
            .title{
                font-family:sy-font,serif;
                font-weight:700;
                color:#1c1c1c;
                font-size:31px;
                margin-left: -18px;
            }

        }
        .right{
            width: 572px;
        }
        .desc{
            width: 100%;
            margin-top: 50px;
            font-family:Source Han Sans CN;
            color: rgba(28, 28, 28, 0.5);
            font-size:16px;
            //text-indent: 30px;
            text-align: justify;
            .m-b-15{
                margin-bottom: 15px;
            }
        }
        .content-img-1{
            width: 572px;
        }
        .content-img-2{
            width: 584px;
            margin-top: 50px;
        }
    }
    .introduction-2 {
        font-size: 0;
        img {
            height: 720px;
        }
    }
    .introduction-container {
        width: 1250px;
        margin: 0 auto;
        padding-top: 131px;
        padding-bottom: 217px;
    }
    .history-section {
        min-height: 748px;
        padding-top: 1px;
        background: url("~@/assets/imgs/bg2.png") center top / cover no-repeat;
        .section-title {
            font-family: sy-font, serif;
            font-weight: 700;
            color: #1c1c1c;
            font-size: 31px;
            line-height: 38px;
            &.center {
                text-align: center;
            }
        }
        .museum-overview {
            width: 817px;
            margin: 0 auto;
            padding: 34px 88px 50px;
            border: 1px solid rgba(28, 28, 28, 0.55);
            box-sizing: border-box;
            .overview-desc {
                margin-top: 25px;
                font-family: "Source Han Sans CN", sans-serif;
                color: rgba(28, 28, 28, 0.72);
                font-size: 16px;
                line-height: 34px;
                text-align: justify;
                text-indent: 32px;
            }
        }
        .leaders-wrapper {
            width: 817px;
            margin: 56px auto 0;
            .leaders-list {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 32px 18px;
                margin-top: 33px;
            }
        }
        .leader-card {
            width: 191px;
            background: #ffffff;
            .leader-img {
                display: block;
                width: 191px;
                height: 274px;
                object-fit: cover;
                background: #a6a2a0;
            }
            .leader-info {
                height: 79px;
                padding: 18px 20px;
                box-sizing: border-box;
                font-family: "Source Han Sans CN", sans-serif;
                color: rgba(28, 28, 28, 0.52);
                font-size: 14px;
                line-height: 22px;
                .leader-position {
                    margin-top: 4px;
                    font-size: 12px;
                }
            }
        }
        .history-scroller {
            min-height: 680px;
            padding: 80px 0 55px;
            overflow: hidden;
            background: #231f1d;
            box-sizing: border-box;
            .history-title {
                font-family: sy-font, serif;
                font-weight: 700;
                color: #ffffff;
                font-size: 34px;
                line-height: 42px;
                text-align: center;
            }
            .history-viewport {
                position: relative;
                width: 100%;
                margin-top: 64px;
                overflow: hidden;
                .history-track {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background: rgba(255, 255, 255, 0.32);
                }
                .history-motion {
                    display: flex;
                    gap: var(--history-item-gap);
                    width: max-content;
                    margin-left: calc((100vw - var(--history-visible-width)) / 2);
                    will-change: transform;
                }
                .history-item {
                    flex: 0 0 var(--history-item-width);
                }
                .timeline-point {
                    position: relative;
                    height: 44px;
                    font-family: sy-font, serif;
                    font-weight: 700;
                    color: rgba(255, 255, 255, 0.86);
                    font-size: 17px;
                    line-height: 24px;
                    text-align: center;
                    span {
                        position: absolute;
                        top: -6px;
                        left: 50%;
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        transform: translateX(-50%);
                        background: #ffffff;
                    }
                    div {
                        margin-top: 18px;
                    }
                }
            }
            .history-card {
                height: 278px;
                padding: 25px 30px;
                border: 1px solid rgba(255, 255, 255, 0.22);
                box-sizing: border-box;
                color: rgba(255, 255, 255, 0.72);
                .history-card-title {
                    padding-bottom: 17px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.38);
                    font-family: sy-font, serif;
                    font-weight: 700;
                    color: rgba(255, 255, 255, 0.88);
                    font-size: 19px;
                    line-height: 28px;
                }
                .history-card-desc {
                    display: -webkit-box;
                    margin-top: 18px;
                    overflow: hidden;
                    font-family: "Source Han Sans CN", sans-serif;
                    font-size: 16px;
                    line-height: 32px;
                    text-align: justify;
                    text-indent: 32px;
                    -webkit-line-clamp: 5;
                    -webkit-box-orient: vertical;
                }
            }
            .history-actions {
                display: flex;
                justify-content: center;
                gap: 10px;
                margin-top: 76px;
                .history-btn {
                    width: 43px;
                    height: 43px;
                    padding: 0;
                    background: rgba(255, 255, 255, 0.1);
                    color: #ffffff;
                    cursor: pointer;
                    font-size: 23px;
                    line-height: 39px;
                    text-align: center;
                    outline: none;
                    &.disabled {
                        opacity: 0.42;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }
}
</style>
